import styled from 'styled-components';

export const FixedDescription = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  line-height: 25px;
  ${props => (props.onClick ? 'cursor: pointer;' : '')}
`;

export const NewButton = styled.div`
  margin-left: 15px;
  cursor: pointer;
`;

export const ButtonSection = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
  > button {
    margin-right: 15px;
  }
`;

export const SmallFormSection = styled.div`
  display: flex;
  flex-direction: column;
`;
